import { render, staticRenderFns } from "./customerRoleRuleSelect.vue?vue&type=template&id=3818795a&scoped=true&"
import script from "./customerRoleRuleSelect.vue?vue&type=script&lang=js&"
export * from "./customerRoleRuleSelect.vue?vue&type=script&lang=js&"
import style0 from "./customerRoleRuleSelect.vue?vue&type=style&index=0&id=3818795a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3818795a",
  null
  
)

export default component.exports